export const TOGGLE_SERVICE = 'ProductDetails::ToggleServices';
